import { useT } from '@eturi/react-i18next'
import type { MetaState } from '../../validators'

export const hasFieldError = <T, El extends HTMLElement = HTMLInputElement>(
	meta: MetaState<T, El>,
) =>
	Boolean(
		(meta.error || (meta.submitError && !meta.dirtySinceLastSubmit)) &&
			meta.touched &&
			meta.submitFailed,
	)

export type FieldErrProps<T = any, El extends HTMLElement = HTMLInputElement> = {
	readonly meta: MetaState<T, El>
}

export const FieldError = <T, El extends HTMLElement = HTMLInputElement>({
	meta,
}: FieldErrProps<T, El>) => {
	const [t] = useT()
	if (!hasFieldError<T, El>(meta)) return null

	const error = meta.error || meta.submitError
	const errorText = isTranslatedError(error) ? error.t : t(error)

	return <div className="validation-error">{errorText}</div>
}

export type TranslatedError = {
	readonly t: string
}

export type FieldErrorValue = string | TranslatedError

const isTranslatedError = (e: any): e is TranslatedError =>
	typeof e == 'object' && e != null && 't' in e

export const tError = (t: string): TranslatedError => ({ t })
